import React from 'react'
import './WhoWeAre.css'

export default function WhoWeAre() {
  return (
    <div className="WhoWeAre">
      <div className="Who-cont">
        <div className='Who-image'></div>
        <div className="Who-text">
          <h2>Who We Are</h2>
          <p>
            RaStegHub is a product-driven technology innovation company dedicated to building digital solutions that help 
            businesses, organizations, and individuals thrive in an increasingly digital world. We believe technology should 
            do more than solve immediate problems; it should create opportunities, improve efficiency, and support sustainable 
            growth.
            <br/>
            Our work is built on two complementary pillars. We design and develop custom software tailored to the unique goals 
            and challenges of every client, while also creating scalable digital products that address common business needs and 
            empower more people through accessible technology. This balance allows us to deliver solutions that are both innovative 
            and practical, combining the flexibility of bespoke development with the long-term value of product innovation.
            <br />
            At RaStegHub, every project begins with understanding. We take time to learn how our clients operate, the challenges
            they face, and the outcomes they hope to achieve before recommending or building a solution. Whether we're developing a website,
            a business management platform, a mobile application, integrating AI, or enhancing an existing system, our goal is to create technology
            that delivers measurable value and grows alongside the people who use it.
            More than a technology company, we see ourselves as a long-term partner in digital transformation. Through 
            collaboration, continuous improvement, and a commitment to quality, we help turn ideas into reliable, scalable,
            and impactful digital solutions that make a lasting difference.
          </p>
        </div>
      </div>
    </div>
  )
}
